var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostepayAm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 101 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0047bb;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Sfumatura_senza_nome_3);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .61px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 2.61,
    y1: 31,
    x2: 99.06,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f3e749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e749"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3,
    y: 2.26,
    width: 96,
    height: 57.47,
    rx: 12.41,
    ry: 12.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.84,39.22h1.71s.95-4.48.95-4.48h.05c.39.93,1.51,1.29,2.25,1.29,3.25,0,4.86-2.46,5.36-4.79.52-2.45-.24-4.79-2.78-4.79-1.43,0-2.65.41-3.45,1.71h-.04l.25-1.44h-1.75c-.08.54-.16,1.08-.25,1.62l-2.32,10.88ZM22.37,31.25c-.36,1.7-1.39,3.55-3.47,3.55-1.91,0-2-1.85-1.65-3.55.35-1.64,1.37-3.55,3.32-3.54,2.05,0,2.15,1.85,1.8,3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.26,26.46c-2.97,0-4.92,1.98-5.52,4.79-.6,2.81.51,4.79,3.48,4.79,2.97,0,4.92-1.98,5.52-4.79.59-2.81-.51-4.79-3.49-4.79M26.55,31.25c.4-1.92,1.41-3.55,3.45-3.54,2.03,0,2.35,1.62,1.95,3.55-.41,1.93-1.42,3.55-3.46,3.55-2.04,0-2.35-1.62-1.94-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.99,26.46c1.71,0,3.49.72,2.93,2.78h-1.8c.31-1.15-.49-1.53-1.48-1.53-.92,0-1.74.43-1.96,1.44-.22,1.01,1.31,1.08,1.92,1.27,1.42.51,3.15.69,2.72,2.72-.47,2.22-2.78,2.9-4.63,2.9s-3.29-.86-2.83-2.95h1.8c-.2,1.12.43,1.71,1.47,1.71,1.01,0,2.12-.4,2.37-1.57.43-2.02-5.39-.51-4.64-4.03.41-1.89,2.49-2.74,4.13-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.97,26.73l.41-1.92,1.83-.54-.53,2.46,2.1-.05-.27,1.28-2.08-.02-1.25,5.83c-.14.65.3.95.91.95.27,0,.64-.03.93-.1l-.28,1.31c-.4.02-.79.1-1.19.1s-.73-.02-1.13-.09c-.26-.05-.68-.2-.88-.59-.22-.43-.3-.47-.04-1.67l1.22-5.75-1.55.02.27-1.28,1.53.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.25,26.26h-2.88c-.09.62-.17,1.27-.31,1.89l-2.4,11.27h2.85l1.06-4.99h.04c.37,1.12,1.33,1.63,2.56,1.63,2.79,0,4.65-2.6,5.17-5.05.55-2.56-.42-5.05-3.38-5.05-.99,0-2.14.59-2.84,1.39h-.04l.18-1.1ZM61.3,31.02c.28-1.3,1.18-3.14,2.72-3.14,1.82,0,1.69,1.69,1.38,3.14-.31,1.46-.9,3.16-2.72,3.16-1.54,0-1.66-1.84-1.38-3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.27,28.95c.05-.43.57-1.36,1.56-1.36s1.14.78,1.06,1.18l-.19.89c-1.13-.04-2.58.02-3.83.51-1.88.74-2.53,2.35-2.67,3.02-.39,1.86.72,2.88,2.51,2.88,1.28,0,2.37-.45,3.25-1.55h.04c-.09.4-.14.83-.17,1.27h2.56c.02-.28,0-.57.09-1.04l1.1-5.2c.62-2.87-1.38-3.57-3.3-3.57-1.02,0-2.06.16-2.93.61-.85.44-1.52,1.18-1.8,2.37h2.74ZM74.35,31.31c-.24,1.12-.67,2.87-2.24,2.87-.8,0-1.26-.57-1.09-1.37.32-1.54,2.35-1.52,3.33-1.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.36 26.27 88.14 26.27 80.57 39.41 77.74 39.41 79.72 35.8 78.08 26.26 81.11 26.27 81.79 32.85 81.83 32.85 85.36 26.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.36,30.65c.37-1.96-.28-3.12-1.55-3.12-1.32,0-2.69.9-3.48,3.12h5.02ZM50.07,31.57c-.61,2.58.36,3.42,1.62,3.42,1.09,0,2-.52,2.8-1.53l1.87.16c-.4.54-1.01,1.12-1.82,1.6-.82.47-1.84.8-3.15.8-1.29,0-2.35-.33-2.93-1.13-.57-.77-.65-1.98-.15-3.71.44-1.53,1.23-2.78,2.32-3.59.96-.71,2.12-1.1,3.5-1.1,1.21,0,2.11.38,2.68,1.17.6.92.63,2.29.16,3.91h-6.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostepayAm);
export default __webpack_public_path__ + "static/media/postepay-am.89ff5d68a349b610bd9f90cc699c44de.svg";
export { ForwardRef as ReactComponent };